<template>
    <div id="page-user-list" class="vx-card p-6">
        <!-- Search area-->
        <vx-card
                ref="filterCard"
                @keyup.enter="pressEnterSearch"
                id="user_list_filters"
                tabindex="0"
                title=""
                class="user-list-filters mb-8"
                actionButtons
                @refresh="resetColFilters"
                @remove="resetColFilters"
        >
            <div class="vx-row">
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">お問い合わせ者</label>
                    <vs-input class=" mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                              id="receive_mail__email_sender_search"
                              v-model="receive_mail__email_sender_search"
                              icon-after="true" :icon="receive_mail__email_sender_search ? iconVsInput : ''"
                              :maxlength="512">
                    </vs-input>
                </div>
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">お問い合わせ日（から）</label>
                    <flat-pickr id="sent_date_search_from"
                                class="w-full flatpickr-style"
                                v-model="receive_date_search_from"
                                placeholder="..."
                                :config="configDate"
                                @on-change="clearFocusTypeDropdown()">
                    </flat-pickr>
                </div>
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">お問い合わせ日（まで）</label>
                    <flat-pickr id="sent_date_search_to"
                                class="w-full flatpickr-style"
                                v-model="receive_date_search_to"
                                placeholder="..."
                                :config="configDate"
                                @on-change="clearFocusTypeDropdown()">
                    </flat-pickr>
                </div>
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">本文</label>
                    <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                              id="body_search"
                              v-model="body_search" icon-after="true" :icon="body_search ? iconVsInput : ''">
                    </vs-input>
                </div>

                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
                <div class="vx-col flex flex-wrap justify-end m-auto mb-0 pt-2 lg:w-1/4 sm:w-1/2 w-full">
                    <vs-button
                            icon="search"
                            @click="onSearch(true)"
                            color="primary"
                            class="ml-2"
                    >検索
                    </vs-button>
                </div>
            </div>
        </vx-card>

        <div class="flex flex-wrap items-center">
            <vs-row class="pb-2 items-center"
                    style="justify-content: space-between;"
                    vs-type="flex">
                <vs-col vs-w="4" class="flex items-center">
                    <vs-col style="width: 111px" class="mr-3">
                        <vs-switch v-model="modeComputed">
                            <span slot="on">プレビュー</span>
                            <span slot="off">プレビュー非表示</span>
                        </vs-switch>
                    </vs-col>
                    <vs-col style="width: 200px" class="flex items-center justify-center">
                        <div style="width: 35%;">
                            表示件数:
                        </div>
                        <div style="width: 60%">
                            <v-select class="square mr-2"
                                      id="pagination_limit"
                                      v-model="pagination.limit"
                                      placeholder="..."
                                      :options="listRowLimit"
                                      :searchable="false">
                            </v-select>
                        </div>
                    </vs-col>
                </vs-col>
                <vs-col vs-w="8"
                        vs-type="flex"
                        vs-align="flex-end"
                        vs-justify="flex-end">
                    <vs-button class="square mr-2"
                               icon=""
                               color="#4472c4"
                               style="min-width: 109px;"
                               @click="handleActiveActionPopUp('restore')"
                               :disabled="listMailTrashSelect.length == 0 || readOnly"
                    >
                        <span>受信に移動</span>
                    </vs-button>
                    <vs-button class="square mr-2"
                               icon="delete"
                               color="danger"
                               @click="handleActiveActionPopUp('delete')"
                               :disabled="listMailTrashSelect.length == 0 || readOnly"
                    >
                        <span>完全に削除</span>
                    </vs-button>
                </vs-col>
            </vs-row>
        </div>
        <!-- AgGrid Table -->
        <div v-if="!modeComputed">
            <ag-grid-vue
                id="myGrid"
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table database ag-grid-customize table-trash"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="listMailTrash"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :pagination="true"
                :domLayout="domLayout"
                :paginationPageSize="paginationPageSize"
                @sort-changed="onSortChanged"
                @grid-ready="onGridReady"
                @row-selected="rowClickChanged"
                :enableRtl="$vs.rtl"
                :overlayNoRowsTemplate="noRowsTemplate"
                :suppressPaginationPanel="true"
                :detailRowAutoHeight="true"
                :getRowStyle="getRowStyle"
            >
            </ag-grid-vue>
            <div style="position: relative">
                <!-- ITEMS PER PAGE -->
                <div>
                    <div class="flex items-center justify-between">
                      <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">
                          {{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示
                      </span>
                    </div>
                </div>
                <vs-pagination
                   v-if="listMailTrash.length > 0"
                   :total="pagination.totalPage"
                   :max="7"
                   v-model="pagination.currentPage"
                   class="pt-10 pr-10"
                />
            </div>
        </div>
        <!--Preview mode-->
        <vs-row v-else vs-type="flex" vs-justify="space-between">
            <vs-col vs-w="4">
                <ag-grid-vue
                    ref="agGridTable"
                    :components="components"
                    :gridOptions="gridOptionsPreview"
                    class="ag-theme-material w-100 my-4 ag-grid-table database overflow-y-auto ag-grid-customize"
                    :columnDefs="previewModeColumnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="listMailTrash"
                    rowSelection="single"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :pagination="true"
                    :domLayout="domLayout"
                    :paginationPageSize="paginationPageSize"
                    :isRowSelectable="() => true"
                    @sort-changed="onSortChanged"
                    @grid-ready="onGridReady"
                    @selection-changed="onPreviewModeSelectionChanged"
                    :enableRtl="$vs.rtl"
                    :overlayNoRowsTemplate="noRowsTemplate"
                    :suppressPaginationPanel="true"
                    :detailRowAutoHeight="true"
                    :getRowHeight="getRowHeight"
                    :isFullWidthCell="isFullWidthCell"
                    :fullWidthCellRenderer="fullWidthCellRenderer"
                    style="max-height: 985px;"
                    :getRowStyle="getRowStyle"
                >
                </ag-grid-vue>

                <div style="position: relative">
                    <!-- ITEMS PER PAGE -->
                    <div>
                        <div class="flex items-center justify-between">
                            <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                        </div>
                    </div>
                    <vs-pagination
                       v-if="listMailTrash.length > 0"
                       :total="pagination.totalPage"
                       :max="7"
                       v-model="pagination.currentPage"
                       class="pt-10 pr-10"
                    />
                </div>
            </vs-col>

            <!--Preview section-->
            <vs-col vs-w="7.75" id="receive-mail-detail" >
                <vs-row class="mt-5  py-2"
                        vs-type="flex"
                        vs-align="flex-end"
                        vs-justify="flex-end">
                    <vs-button class="square"
                               color="#4478b8"
                               @click="editMailDetail(preview_detail)"
                               :disabled="!preview_detail.id"
                    >
                        <span><feather-icon icon="EditIcon" class="cursor-pointer" svg-classes="h-6 w-6"></feather-icon></span>
                        <img hidden id="img-error" src="@/assets/images/other-icons/error.png"/>
                    </vs-button>
                </vs-row>

                <vs-row>
                    <vs-col>
                        <vx-input-group>
                            <template slot="prepend">
                                <div class="prepend-text label-style">
                                    <span>ID</span>
                                </div>
                            </template>
                            <vs-input readonly class="disabled-input" v-model="preview_detail.inquiry_id" placeholder="" />
                        </vx-input-group>
                    </vs-col>
                    <vs-col>
                        <vx-input-group class ="square" type="file">
                            <template slot="prepend">
                                <div class="prepend-text label-style">
                                    <span>From</span>
                                </div>
                            </template>
                            <vs-input readonly class="disabled-input" v-model="preview_detail.email_sender_full" placeholder="" />
                        </vx-input-group>
                    </vs-col>
                    <vs-col>
                        <vx-input-group>
                            <template slot="prepend">
                                <div class="prepend-text label-style">
                                    <span>To</span>
                                </div>
                            </template>

                            <vs-input readonly class="disabled-input" v-model="preview_detail.to" placeholder="" />
                        </vx-input-group>
                    </vs-col>
                    <vs-col>
                        <vx-input-group>
                            <template slot="prepend">
                                <div class="prepend-text label-style">
                                    <span>CC</span>
                                </div>
                            </template>

                            <vs-input readonly class="disabled-input" v-model="preview_detail.cc" />
                        </vx-input-group>
                    </vs-col>
                    <vs-col class="mt-5" v-if="preview_detail.error_detail">
                        <div class="prepend-text label-style w-full" style="padding:10px">
                            <span class="mr-5"><img src="@/assets/images/other-icons/error.png" style="position: relative;top: 3px;"/></span>
                            <span>エラー内容</span>
                        </div>
                        <vx-card
                            class="card-body-mail disabled-input"
                            no-radius
                            cardBorder
                        >
                            <div
                                class="w-full"
                                v-html="preview_detail.error_detail"
                                style="height: 150px; overflow-y: scroll"
                            ></div>
                        </vx-card>
                    </vs-col>
                    <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
                        <vx-input-group>
                            <template slot="prepend">
                                <div class="prepend-text label-style" style="width: 120px">
                                    <span>添付ファイル</span>
                                </div>
                            </template>
                            <vs-row>
                                <vs-col
                                    style="width: max-content; padding: 3px 5px"
                                    :key="index"
                                    v-for="(value, index) in preview_detail.attachmentFileName"
                                >
                                    <div @click="downloadAttachment(value.path)">
                                        <vs-chip
                                            style="cursor: pointer"
                                            class="mt-1"
                                            color="dark"
                                            transparent
                                        >{{ value.file_name }}</vs-chip
                                        >
                                    </div>
                                </vs-col>
                            </vs-row>
                        </vx-input-group>
                    </vs-col>
                </vs-row>

                <vs-row class="mt-6">
                    <vx-card
                        class="card-body-mail disabled-input"
                        no-radius
                        cardBorder
                        noShadow
                        title="件名"
                    >
                        <div
                            class="w-full"
                            v-html="preview_detail.subject"
                            style="padding: 9.8px"
                        ></div>
                    </vx-card>

                    <vx-card
                        class="card-body-mail disabled-input"
                        no-radius
                        cardBorder
                        noShadow
                        title="お問い合わせ本文"
                    >
                        <div
                            id="receiveMailBodyBlock"
                            class="pl-2 pt-2"
                            v-if="preview_detail.body_type == 0"
                            v-html="preview_detail.body"
                            style="height: 560px; overflow-y: scroll"
                        ></div>
                        <vs-textarea
                            id="receiveMailBodyTextarea"
                            v-else
                            readonly
                            v-model="preview_detail.body"
                            placeholder="..."
                            height="560px"
                        />
                    </vx-card>
                </vs-row>
            </vs-col>
        </vs-row>

        <!-- dialog confirm delete or restore-->
        <vs-popup ref="dialogConfirm" :title="popupTitle" :active.sync="activeActionPopUp" button-close-hidden>
            <div>
                <span>{{ popupMessage }}</span>
            </div>
            <div class="flex justify-end">
                <vs-button @click="handleActionSelect" :color="confirmButtonProps.color" :icon="confirmButtonProps.icon" style="padding: 8px; margin-right: 5px;height: 37px; min-width: 79px;">はい</vs-button>
                <vs-button @click="activeActionPopUp = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import Vue from "vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { AgGridVue } from "ag-grid-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CellRendererCheckbox from "@/components/cell-renderer/CellRendererCheckbox";
import CellRendererPriority from "@/components/cell-renderer/CellRendererPriority";
import {handleDownloadAttachment, setupIconClickEvent, notifyEmptyTrash} from "@/utils/helpler-utils";
import CellRendererError from "@/components/cell-renderer/CellRendererError.vue";

Vue.component('cell-priority',CellRendererPriority)
Vue.component('cell-error',CellRendererError)

export default {
    components: {
        AgGridVue,
        vSelect,
        flatPickr,
        CellRendererCheckbox,
        CellRendererPriority,
        CellRendererError,
    },
    data() {
        return {
            iconVsInput:'close',
            readOnly: false,
            isCreated: true,

            receive_date_search_from: '',
            receive_date_search_to: '',
            body_search: '',
            receive_mail__email_sender_search: "",

            configDate: {
                locale: Japanese,
                wrap: true,
                defaultHour: 0,
                maxDate: "",
            },

            startRow: 0,
            endRow: 0,
            pagination: {
                totalPage: 0,
                currentPage:
                    this.searchFilter &&
                    this.searchFilter.queries &&
                    this.searchFilter.queries.page
                        ? this.searchFilter.queries.page
                        : 1,
                limit: 10,
                totalItem: 0,
                from: 1,
                to: 10,
            },
            orderBy: "receive_datetime",
            orderDir: "desc",

            // AgGrid
            noRowsTemplate: "<span>データがありません</span>",
            domLayout: "autoHeight",
            gridApi: null,
            columnApi: null,
            isRowSelectable: null,
            gridOptions: {
                onGridSizeChanged: () => {
                    this.gridApi.sizeColumnsToFit();
                },
                onCellClicked: (cell) => {
                    if (cell.value !== undefined){
                        this.editMailDetail(cell.data)
                    }
                },
                suppressRowClickSelection: true,
            },
            gridOptionsPreview: {
                onGridSizeChanged: () => {
                    this.gridApi.sizeColumnsToFit();
                },
            },
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                sortingOrder: ["asc", "desc"],
            },
            columnDefs: [
                {
                    width: 50,
                    filter: true,
                    checkboxSelection: (params) => {
                        return true;
                    },
                    headerCheckboxSelectionFilteredOnly: true,
                    headerCheckboxSelection: true,
                    suppressMovable: true,
                },
                {
                    headerName: "",
                    width: 40,
                    cellRendererFramework: "cell-error",
                    suppressMovable: true,
                },
                {
                    headerName: "方法",
                    field: "inquiry_type_text",
                    width: 75,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "回答期日",
                    field: "response_limit",
                    width: 100,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "状態",
                    field: "state_flg_text",
                    width: 130,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "種別",
                    field: "type_text",
                    width: 100,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "優先度",
                    field: "priority",
                    width: 60,
                    cellRendererFramework: "cell-priority",
                    suppressMovable: true,
                },
                {
                    headerName: "お問い合わせID",
                    field: "inquiry_id",
                    width: 150,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "お問い合わせ日",
                    field: "receive_datetime",
                    width: 160,
                    unSortIcon: true,
                    sort: "desc",
                    suppressMovable: true,
                },
                {
                    headerName: "担当者",
                    field: "full_name",
                    width: 150,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "分類",
                    field: "matching_status",
                    width: 75,
                    unSortIcon: false,
                    sortable: false,
                    suppressMovable: true,
                },
                {
                    headerName: "タイトル",
                    field: "subject",
                    width: 200,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "お問い合わせ者",
                    field: "email_sender_full_table",
                    width: 200,
                    sortable: false,
                    suppressMovable: true,
                },
                {
                    headerName: "メール本文",
                    field: "parsed_body",
                    width: 200,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "送信済み",
                    field: "check_replied_mail",
                    width: 100,
                    sortable: false,
                    suppressMovable: true,
                    cellClass: 'text-center',
                },
                {
                    headerName: "保存先フォルダ",
                    field: "folder_path",
                    width: 110,
                    unSortIcon: true,
                    sortable: true,
                    suppressMovable: true,
                },
            ],

            // Cell Renderer Components
            components: {
            },
            //Preview Mode
            previewModeColumnDefs: [
                {
                    headerName: "",
                    field: "id",
                    width: 200,
                    unSortIcon: true,
                    suppressMovable: true,
                },
            ],
            getRowHeight: null,
            fullWidthCellRenderer: null,
            isFullWidthCell: null,
            selectedPreviewMail: {},
            listMailTrashSelect: [],

            //PAC_21-91
            listRowLimit: [
                '10',
                '25',
                '50'
            ],
            activeActionPopUp: false,
            typeAction: null
        };
    },
    watch: {
        'pagination.limit': function () {
            this.pagination.currentPage = 1;
            this.onSearch(false);
        },
        async $route(to, from) {
            /* start loading with many requests */
            this.$store.dispatch("updateLoads", true);
            // this.clearSearchFilter();
            this.listMailTrashSelect = [];

            let mailBox = this.$route.params.email;
            if (mailBox) {
            } else if (this.listMailBox && this.listMailBox.length > 0) {
                mailBox = this.listMailBox[0].receive_user_name;
            }
            if (mailBox) {
                this.orderBy = "receive_datetime";
                this.orderDir = "desc";
                this.gridApi.setSortModel({ colId: "delete_at", sort: "desc" });
                await this.getListMailBox();
                await this.onSearch(true, mailBox);
            }

            /* stop loads */
            this.$store.dispatch("updateLoads", false);
        },
        "pagination.currentPage": {
            deep: true,
            immediate: true,
            handler: function (val) {
                if (!this.isCreated) this.paginationPage(val);
            },
        },
    },
    beforeMount() {
        this.isRowSelectable = (params) => {
            return true;
        };
        this.isFullWidthCell = (rowNode) => {
            if (this.mode == true) {
                return rowNode.data;
            }
        },
        this.fullWidthCellRenderer = (params) => {
            let cellClass = "cell-full-width ";
            const eDiv = document.createElement("div");
            const eSrcImg = params.data.error_detail ? document.getElementById("img-error").getAttribute("src") : "";
            eDiv.innerHTML = `<div class=${cellClass}>
                <div class="mail-header">
                  <span><img src="${eSrcImg}"/></span>
                  <span>${params.data.email_sender}</span>
                  <span>${params.data.receive_datetime}</span>
                </div>
                <br><span style="font-size:15px; line-height: 1.5">${params.data.subject}</span></div>
              </div>`;
            return eDiv.firstChild;
        };
        this.getRowHeight = () => {
            if (this.mode == true) {
                return 85;
            } else {
                return 50;
            }
        };
    },
    computed: {
        ...mapGetters({
            listMailBox: "receiveMail/listMailBox",
            currentMailBoxSelected: "receiveMail/currentMailBoxSelected",
            listMailTrash: "mailTrash/listMailTrash",
            searchFilter: "mailTrash/getSearchFilter",
            mode: "mailTrash/mode",
        }),
        paginationPageSize() {
            return this.pagination.limit
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0;
        },
        totalRow() {
            return parseInt(this.pagination.totalItem);
        },
        preview_detail() {
            return this.selectedPreviewMail ? this.selectedPreviewMail: {};
        },
        modeComputed: {
            get() {
                return this.mode;
            },
            async set() {
                await this.setMode();
            },
        },
        popupTitle() {
            return this.typeAction === 'restore'
                ? '受信に移動'
                : '完全に削除';
        },
        popupMessage() {
            return this.typeAction === 'restore'
                ? '選択したメールを受信に移動しますか？'
                : '選択したメールを完全に削除しますか？';
        },
        confirmButtonProps() {
            return this.typeAction === 'restore'
                ? { icon: '', color: '#4472c4' }
                : { icon: 'delete', color: 'danger' };
        }
    },
    methods: {
        ...mapActions({
            getListMailBox: "receiveMail/getListMailBox",
            getListMailTrash: "mailTrash/getListMailTrash",
            clearSearchFilter: "mailTrash/clearSearchFilter",
            restoreMailTrash: "mailTrash/restoreMailTrash",
            deletePermanentlyMailTrash: "mailTrash/deletePermanentlyMailTrash",
            setMode: "mailTrash/setMode",
            getSelectedMailPreviewMode: "moduleEmail/getSelectedMailPreviewMode",
            downloadFile: "receiveMail/downloadAttachment",
            setUserReadOnly: "receiveMail/setUserReadOnly",
        }),
        ...mapMutations({
            setSearchFilter: "mailTrash/SET_SEARCH_FILTER",
        }),
        clearInput(modelExpression) {
            this[modelExpression] = ""; // Clear the value input
        },
        pressEnterSearch() {
            this.onSearch(true)
        },
        clearFocusTypeDropdown() {
            this.$nextTick(() => {
                document.activeElement.blur()
                document.getElementById('user_list_filters').focus()
            })
        },
        async paginationPage(value) {
            if (!this.isCreated) {
                this.pagination.currentPage = value;
                let mailBox = this.$route.params.email;
                if (mailBox) {
                } else if (this.listMailBox && this.listMailBox.length > 0) {
                    mailBox = this.listMailBox[0].receive_user_name;
                }
                await this.onSearch(false, mailBox);
            }
        },
        getRowStyle(params) {
            const { data } = params; //is_read d4ecea
            return (data.is_read == 1) ? { background: '#eee' } : null;
        },
        rowClickChanged(event) {
            //Check row is selected
            let selected = event.node.selected;
            if (selected) {
                this.listMailTrashSelect.push(event.data.id);
            } else {
                this.listMailTrashSelect = this.listMailTrashSelect.filter(id => id != event.data.id)
            }
        },
        onSortChanged(event) {
            let columns = event.columnApi.getAllColumns();
            let root = this;
            columns.forEach(function (column) {
                if (column.getSort()) {
                    root.orderDir = column.getSort();
                    root.orderBy = column.getColId();
                    root.onSearch(false);
                }
            });
        },
        async onSearch(resetPaging, mailBox = null) {
            let action = "";
            if (resetPaging === true && mailBox === null) {
                action = "search";
            }

            if (mailBox === null) {
                mailBox = this.currentMailBoxSelected
            } else {
                this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', mailBox)
            }

            if (this.orderBy) {
                const orderByMap = {
                    "state_flg_text": "state_flg",
                    "inquiry_type_text": "inquiry_type",
                    "type_text": "type",
                    "parsed_body": "body",
                    "folder_path": "folder"
                };

                if (orderByMap.hasOwnProperty(this.orderBy)) {
                    this.orderBy = orderByMap[this.orderBy];
                }
            }
            let page = this.pagination.currentPage;
            if (resetPaging === true) page = 1;
            if (this.isCreated)
                page =
                    this.searchFilter && this.searchFilter.mailBox === mailBox
                        ? this.searchFilter.queries.page
                        : 1;
            let params = {
                mailBox: mailBox,
                queries: {
                    receive_datetime_from: this.receive_date_search_from || null,
                    receive_datetime_to: this.receive_date_search_to || null,
                    receive_mail_email_sender: this.receive_mail__email_sender_search || null,
                    body: this.body_search || null,
                    action: action,
                    page: page,
                    limit: this.pagination.limit,
                    orderBy: this.orderBy,
                    orderDir: this.orderDir,
                },
            };
            let data = await this.getListMailTrash(params);
            this.handleMailSelected();
            this.setSearchFilter(params);

            this.pagination.totalItem = data.total;
            this.pagination.totalPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.limit = data.per_page;
            this.pagination.from = data.from;
            this.pagination.to = data.to;

            // If there is no data left and it is not the first page, go back to the previous page.
            if (data.data.length == 0 && this.pagination.currentPage > 1) {
                this.pagination.currentPage--;
                this.onSearch(false);
            }
            //Load preview mode
            if (this.mode) this.loadPreview();
        },
        clearSearchCommon() {
            this.receive_date_search_from = ''
            this.receive_date_search_to = ''
            this.receive_mail__email_sender_search = "";
            this.body_search = ''
            this.listMailTrashSelect = [];
        },
        async resetColFilters() {
            // Reset Grid Filter
            this.gridApi.setFilterModel(null);
            this.gridApi.onFilterChanged();
            this.clearSearchFilter();
            this.clearSearchCommon();
            await this.onSearch(true);
            this.$refs.filterCard.removeRefreshAnimation();
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            if (this.mode) {
                this.loadPreview();
            }
        },
        async handleActionSelect () {
            let ids = this.listMailTrashSelect;
            let params = {
                mailBox: this.$route.params.email,
                id: ids,
            }

            if (ids.length === 0) return;

            if (this.typeAction == "restore") {
                await this.restoreMailTrash(params)
            } else {
                // delete Permanently
                await this.deletePermanentlyMailTrash(params)
            }

            this.listMailTrashSelect = [];
            this.activeActionPopUp = false;

            // Ensure current page is valid after deleting items
            const newTotalItems = this.pagination.totalItem - ids.length;
            const maxPage = Math.ceil(newTotalItems / this.pagination.limit);

            // If the current page exceeds the new maximum page, revert
            if (this.pagination.currentPage > maxPage) {
                this.pagination.currentPage = Math.max(1, maxPage);
            }

            await this.onSearch(false)
        },
        async refreshPageTrash() {
            if (localStorage.refreshPageTrash) {
                localStorage.removeItem("refreshPageTrash");
                let mailBox = this.$route.params.email;
                if (mailBox) {
                    this.orderBy = "receive_datetime";
                    this.orderDir = "desc";
                    await this.sleep(1500);
                    await this.onSearch(false, mailBox);
                }
            }
        },
        async sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async onPreviewModeSelectionChanged() {
            let mailBox = this.$route.params.email;
            let selectedRows = this.gridApi.getSelectedRows();
            let params = {
                mailBox: mailBox,
                id: selectedRows[0].id,
                type: 2 // trash
            }
            try {
                let selectedReceiveMail = await this.getSelectedMailPreviewMode(params);
                selectedReceiveMail.attachmentFileName = [];
                if (selectedReceiveMail.attachment_filepath){
                    let listattachmentFiles = selectedReceiveMail.attachment_filepath.split(',')
                    listattachmentFiles.forEach((element)=>{
                        selectedReceiveMail.attachmentFileName.push({
                            path: element,
                            file_name: element.split('/').reverse()[0]
                        })
                    });
                }
                this.selectedPreviewMail = selectedReceiveMail;

                const scrollElement = this.preview_detail.body_type ? 'previewDetailBodyTextarea' : 'previewDetailBodyBlock';
                const topScrollElement = document.getElementById(scrollElement);
                if (topScrollElement) topScrollElement.scrollTop = 0;

            } catch (error) {
                const message = (error && error.response.data && error.response.data.message) || notifyEmptyTrash;
                this.$vs.notify({
                    position: 'bottom-right',
                    text: message,
                    color: 'danger'
                });
                if (error.response.status == 410) {
                    await this.sleep(500);
                    await this.onSearch(false, mailBox);
                }
            }
        },
        loadPreview() {
            if (this.selectedPreviewMail) {
                let isNewPage = true;
                this.gridApi.forEachNode((node) => {
                    isNewPage =
                        this.selectedPreviewMail.id == node.data.id ? false : isNewPage;
                    node.setSelected(
                        this.selectedPreviewMail.id == node.data.id,
                        true,
                        true
                    ); //Prevent call back to onPreviewModeSelectionChanged
                });
                if(!isNewPage) {
                    // refresh data while mail is selected
                    this.onPreviewModeSelectionChanged();
                }
                //Set node[0] when direct to new page
                if (isNewPage && this.gridApi.getRowNode(0)) this.gridApi.getRowNode(0).setSelected(true);
                else if (this.listMailTrash && this.listMailTrash.length == 0) this.selectedPreviewMail = {};
            } else {
                this.gridApi.getRowNode(0).setSelected(true);
            }
        },
        async downloadAttachment(file) {
            let data = {
                "id" : this.preview_detail.id,
                "fileName" : file,
            }
            let result = await this.downloadFile(data);
            if (result) {
                handleDownloadAttachment(result);
            }
        },
        async editMailDetail(mail_detail) {
            const id = mail_detail.id;
            let mailBox = this.$route.params.email;
            try {
                let params = {
                    mailBox: mailBox,
                    id: id,
                    type: 2 // trash
                }
                let checkMailReceive = await this.getSelectedMailPreviewMode(params);
                if (checkMailReceive) {
                    let mail = this.listMailTrash.find((item) => item.id == id);
                    if (mail && mail.inquiry_id) {
                        let routePath = `/trash/${this.currentMailBoxSelected}/${mail.inquiry_id}?back=true`;
                        window.open(routePath, '_blank');
                    }
                }
            } catch (error) {
                this.$vs.notify({
                    position: 'bottom-right',
                    text: notifyEmptyTrash,
                    color: 'danger'
                });
                await this.onSearch(false, mailBox);
                return false;
            }
        },
        handleMailSelected(){
            this.gridApi.forEachNode(node => {
                //Check row id exist in list Selected
                let checkExist = this.listMailTrashSelect.filter(id => id == node.data.id).length == 0 ? false : true;
                if (checkExist) {
                    node.setSelected(true);
                }
            });
        },
        handleActiveActionPopUp(type){
            this.typeAction = type;
            this.activeActionPopUp = true;
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        /* =================================================================
          NOTE:
          Header is not aligned properly in RTL version of agGrid table.
          However, we given fix to this issue. If you want more robust solution please contact them at gitHub
        ================================================================= */
        if (this.$vs.rtl) {
            const header = this.$refs.agGridTable.$el.querySelector(
                ".ag-header-container"
            );
            header.style.left = `-${String(
                Number(header.style.transform.slice(11, -3)) + 9
            )}px`;
        }

        this.clearSearchFilter();
        // addEventListener Reload => clear
        window.addEventListener("beforeunload", this.resetColFilters);
        window.addEventListener('storage', this.refreshPageTrash);
        setupIconClickEvent();
    },
    async created() {
        /* start loading with many requests */
        this.$store.dispatch("updateLoads", true);

        let mailBox = this.$route.params.email;
        // await this.getListMailBox();
        if (!mailBox) {
            if (this.listMailBox && this.listMailBox.length > 0) {
                mailBox = this.listMailBox[0].receive_user_name;
            }
        } else {
            if (
                this.listMailBox &&
                this.listMailBox.length > 0 &&
                this.listMailBox.find((mb) => mb.receive_user_name == mailBox)
            ) {
                //...
            } else mailBox = null;
        }

        if (mailBox) {
            this.clearSearchFilter();
            await this.onSearch(false, mailBox);
            this.isCreated = false;
        } else this.$router.push({ path: "/dashboard" });

        /* stop loads */
        this.readOnly = await this.setUserReadOnly(mailBox) > 0;
        this.$store.dispatch("updateLoads", false);
    },
    updated() {
        this.$nextTick(() => {
            if (!this.$store.state.loading && this.listMailTrash.length > 0) {
                this.startRow =
                    this.pagination.currentPage * this.pagination.limit -
                    this.pagination.limit +
                    1;
                if (this.listMailTrash.length == this.pagination.limit)
                    this.endRow = this.pagination.currentPage * this.pagination.limit;
                else
                    this.endRow =
                        this.pagination.limit * this.pagination.currentPage +
                        this.listMailTrash.length -
                        this.pagination.limit;
            } else if (this.listMailTrash.length == 0) {
                this.pagination.totalItem = 0;
                this.startRow = 0;
                this.endRow = 0;
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.resetColFilters, {
            passive: true,
        });
        window.removeEventListener("storage", this.refreshPageTrash)
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/mailBox.scss";
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";

.table-trash {
  .ag-cell,
  .ag-header-cell {
    padding-inline: 10px !important;
  }
}
</style>
